// ─── Application entry point ───────────────────────────────────────────────────

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import logger from './utils/logger';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Log web vitals in development
reportWebVitals((metric: unknown) => {
  logger.debug('Web Vital', metric);
});
